/** Plausible European mains band — rejects QuestDB zeros / missing FOP sentinels. */
export function normalizeFopHz(raw: number | null | undefined): number | null {
  if (raw == null) return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 45 || n > 55) return null;
  return n;
}

export function freqYRange(values: number[]): [number, number] | undefined {
  const ys = values.filter((v) => Number.isFinite(v));
  if (!ys.length) return undefined;
  const min = Math.min(...ys);
  const max = Math.max(...ys);
  const pad = Math.max((max - min) * 0.15, 0.003);
  return [min - pad, max + pad];
}
